import { commonV3URL } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from 'src/actions/alertAction';
import helperAxios from 'src/utils/helperAxios';
import getProductType from 'src/components/ProductType';

export const GET_HOME_DETAILS = '@home/get-home';
export const GET_HOME_DETAILS_ERROR = '@home/get-home-error';
export const GET_HOME_DETAILS_EMPTY = '@home/get-home-empty';

export function getHomeDetails(clientId) {
  const url = `${commonV3URL}/report/homeDetails?clientId=${clientId}`;
  const request = helperAxios(url, 'get');

  const productType = getProductType();

  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_HOME_DETAILS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_HOME_DETAILS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: `/${productType.toLowerCase()}/reports`
        });
      });
  };
}

export const homeDetailsEmpty = () => {
  return dispatch => {
    dispatch({ type: GET_HOME_DETAILS_EMPTY });
  };
};
